import frenchJson from './fr.json';
import englishJson from './en.json';

export function getLang() {
  let defaultLang = 'en';
  if (typeof window !== 'undefined') {
    const lang = navigator.language || navigator.userLanguage;
    defaultLang = lang.slice(0, 2) || defaultLang;
  }
  return defaultLang;
}

export const messages = {
  en: englishJson,
  fr: frenchJson,
};
